import { render, staticRenderFns } from "./DatePickerStdView.vue?vue&type=template&id=0540365f&scoped=true&"
import script from "./DatePickerStdView.vue?vue&type=script&lang=js&"
export * from "./DatePickerStdView.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerStdView.vue?vue&type=style&index=0&id=0540365f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540365f",
  null
  
)

export default component.exports